const PENDENTE = "PENDENTE";
const ACEITO = "ACEITO";
const ENTREGA = "ENTREGA";
const CONCLUIDO = "CONCLUIDO";

export { PENDENTE, ACEITO, ENTREGA, CONCLUIDO };
